import { KPIDetailsGroupDataType } from "../../../../stores/types/campaignsTypes.tsx";
import {
  CellContext,
  ColumnDef,
  ColumnPinningState,
} from "@tanstack/react-table";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-light-svg-icons";
import { fullFormatNumbers } from "../../../../helpers/functions/formatNumber.ts";
import { RevMediaPlanTable } from "../table/RevMediaPlanTable.tsx";
import { MediaPlanKpiSubComponent } from "../table/components/MediaPlanKpiSubComponent.tsx";
import { kpiFieldNameData } from "../data/mediaPlanData.ts";

type Props = {
  kpi: KPIDetailsGroupDataType[];
  kpiFields: string[];
  edit: boolean;
};
export const KPIDetailsView = ({ kpi, kpiFields, edit }: Props) => {
  const [columnPinning, setColumnPinning] = useState<ColumnPinningState>({
    left: ["expander"],
  });
  const columns: ColumnDef<KPIDetailsGroupDataType>[] = [
    {
      id: "channels",
      header: () => <div className="w-full text-center">Channels</div>,
      columns:
        kpi.length > 0
          ? [
              {
                id: "expander",
                size: 206,
                header: () => null,
                cell: ({ row }) => {
                  return (
                    row.getCanExpand() &&
                    (row.original.sub_groups ? (
                      <button
                        {...{
                          onClick: row.getToggleExpandedHandler(),
                        }}
                        className="cursor-pointer grid grid-cols-[32px_1fr] w-[174px]"
                      >
                        <div className="flex items-center h-full">
                          <FontAwesomeIcon
                            icon={faChevronRight}
                            className={`text-md text-monochrome-600 ${row.getIsExpanded() ? "rotate-90" : ""}`}
                          />
                        </div>
                        <div className="gap-y-0.5 flex flex-col items-start">
                          <p className="typography-body-sm text-monochrome-900">
                            {row.original.name}
                          </p>
                          <p className="typography-body-xs text-monochrome-500 whitespace-nowrap text-ellipsis overflow-hidden max-w-[135px]">
                            {row.original.sub_groups
                              .map((sub) => sub.name)
                              .join(", ")}
                          </p>
                        </div>
                      </button>
                    ) : (
                      <div className="cursor-pointer grid grid-cols-[32px_1fr]">
                        <div />
                        <p className="typography-body-sm text-monochrome-900">
                          {row.original.name}
                        </p>
                      </div>
                    ))
                  );
                },
              },
            ]
          : undefined,
    },
    {
      header: "KPIs",
      columns:
        kpi.length > 0
          ? kpiFields.map((kpi) => {
              return {
                accessorKey: kpi,
                id: kpi,
                header: () => (
                  <div className="w-full text-end capitalize min-w-[118px]">
                    {kpiFieldNameData[kpi]}
                  </div>
                ),
                cell: ({
                  row,
                }: CellContext<KPIDetailsGroupDataType, unknown>) => {
                  const originalData = row.original;
                  return (
                    <div className="gap-y-0.5 flex flex-col items-end">
                      <p className="typography-body-sm text-monochrome-900">
                        $
                        {fullFormatNumbers({
                          value: originalData.kpis[kpi],
                          noFormatNumber: true,
                          shortenValue: 1e3,
                        })}
                      </p>
                    </div>
                  );
                },
              };
            })
          : undefined,
    },
  ];
  return (
    <RevMediaPlanTable<KPIDetailsGroupDataType>
      data={kpi || []}
      columns={columns}
      getRowCanExpand={() => true}
      renderSubComponent={MediaPlanKpiSubComponent}
      columnPinning={columnPinning}
      onColumnPinningChange={setColumnPinning}
      edit={edit}
    />
  );
};
